<template>
  <div id="welcome">
    <div class="content">
      <div class="main-title">
        <div style="display: flex;height: 22px;margin-left: 16px;padding-top: 24px;">
          <div class="title-line"></div>
          <div class="title-name">员工人数</div>
        </div>
        <div class="main-num">
          {{ num }}
        </div>
      </div>
      <div class="stat-content">
        <div class="item-stat" @click="toLink(1)">
          <div class="num">{{total.pendingCount}}</div>
          <div class="text">我发起的</div>
        </div>
        <div class="item-stat" @click="toLink(2)">
          <div class="num">{{total.processedCount}}</div>
          <div class="text">我处理的</div>
        </div>
        <div class="item-stat" @click="toLink(3)">
          <div class="num">{{total.ccToMeCount}}</div>
          <div class="text">抄送给我的</div>
        </div>
        <div class="item-stat" @click="toLink(4)">
          <div class="num">{{readCount.unread || 0}}</div>
          <div class="text">未读通知</div>
        </div>
      </div>
      <div class="main-content">
        <div style="height: 350px;">
          <img src="../../assets/img_guihuazhong.png" style="width: 320px;height: 320px;" />
          <div class="info">功能规划中，敬请期待~</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "welcome",
  data() {
    return {
      message: "welcome",
      num: 0,
      total:{
        ccToMeCount:0,
        pendingCount:0,
        processedCount:0,
      },
    };
  },
  computed: {
    readCount() {
      return this.$store.state.readCount
    }
  },
  mounted() { },
  created() {
    this.getNum()
  },
  methods: {
    getNum() {
      this.axios.get('/oa/sys/employee/count').then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.num = res.data || 0

        } else {
          this.$message.error(res.message)
        }
      })
      this.axios.get('/oa/workflow/process/count').then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.total = res.data || 0

        }
      })
    },
     // 跳转链接
     toLink(type) {
      const routeMap = {
        1: '/officeApproval/approvalMyList',//我发起的
        2: '/officeApproval/approvalManageList',// 我处理的
        3: '/officeApproval/approvalCCList',// 抄送给我的
        4: '/notice'// 未读通知
      };
      const url = routeMap[type];
      if (type === 4) {
        this.$router.push(url);
      }else if (url) {
        this.setLink(url);
      }
    },
    setLink(url) {
      const currentUrl = localStorage.getItem('selectedMenuIndex');
      if (currentUrl !== url) {
        localStorage.setItem('selectedMenuIndex', url);
      }
      this.$router.push(url);
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  // padding-left: 16px;
  // padding-right: 16px;
  width: 100%;
  height: calc(100vh - 126px);
  margin-top: 16px;
  box-sizing: border-box;

  .main-title {
    width: 100%;
    height: 121px;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;

    .title-line {
      width: 2px;
      height: 16px;
      background: #00B498;
      border-radius: 0px 0px 0px 0px;
      margin-top: 4px;
    }

    .title-name {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 16px;
      color: #2F3030;
      margin-left: 4px;
      line-height: 22px;
    }

    .main-num {
      width: 100%;
      height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: D-DIN Exp-DINExp, D-DIN Exp-DINExp;
      font-weight: bold;
      font-size: 32px;
      color: #2F3030;
      line-height: 22px;
      margin-top: 16px;
    }
  }
  .stat-content {
    display: flex;
    gap: 16px;
    margin-top: 16px;
    .item-stat{
      background-color: #FFF;
      border-radius: 8px;
      height: 120px;
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      box-sizing: border-box;
      padding-top: 16px;
      cursor: pointer;
      // &:hover{
      //   background-color: #E4F7F4;
      // }
    }
    .num{
      font-family: D-DIN Exp-DINExp, D-DIN Exp-DINExp;
      font-weight: bold;
      font-size: 32px;
      color: #2F3030;
      margin-bottom: 8px;
    }
    .text{
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #939696;
    }
  }
  .main-content {
    width: 100%;
    height: calc(100vh - 422px);
    background-color: white;
    margin-top: 16px;
    border-radius: 8px;
    
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;

    .info {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #2F3030;
      line-height: 20px;
      text-align: center;
    }
  }
}

// #welcome {
//   font-size: 20px;

//   div {
//     img {
//       width: 90%;
//       min-width: 700px;
//       margin: 50px auto 20px auto;
//     }
//   }
// }
</style>
